import useCurrentOrgDetailsFetching from '@shared/hooks/useCurrentOrgDetailsFetching';
import { CrumbRouteObject } from '@shared/models/CrumbRouteHandle';
import { useTranslation } from 'react-i18next';
import { useMatches, useParams } from 'react-router';

export default function useBreadcrumbs() {
    const matches = useMatches() as CrumbRouteObject[];
    const { t } = useTranslation();
    const { organizationId, managedOrgId } = useParams(); // Get the dynamic params
    const { currentOrg } = useCurrentOrgDetailsFetching(); // Get current organization details

    const items = matches
        .filter((match) => match.handle?.crumbKey)
        .map((match) => {
            let crumbKey = match.handle?.crumbKey || '';

            // Replace :organizationId or :managedOrgId with the actual organization name if available
            let dynamicLabel = '';

            if (organizationId && !managedOrgId && currentOrg?.name) {
                dynamicLabel = crumbKey.replace('common:organization.title', currentOrg.name);
            }
            if (managedOrgId && currentOrg?.name) {
                dynamicLabel = crumbKey.replace('common:organization.managed.title', currentOrg.name);
            }

            const breadcrumbLabel = t(dynamicLabel || crumbKey);
            return {
                label: String(breadcrumbLabel) || '',
                href: match.pathname ? `${match.pathname}` : '',
            };
        });

    return { items, matches };
}
